import { render, staticRenderFns } from "./LessonDetail.vue?vue&type=template&id=905517d4"
import script from "./LessonDetail.vue?vue&type=script&lang=js"
export * from "./LessonDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports